import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/testResultAndAdvice/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/testResultAndAdvice/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/testResultAndAdvice/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/testResultAndAdvice/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/testResultAndAdvice/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/testResultAndAdvice/getByIds',
    method: 'GET',
    params})
}

   

export function init(data) {

  return request({
    url: '/testResultAndAdvice/init',
    method: 'POST',
    data})
}

   

export function list(params) {

  return request({
    url: '/testResultAndAdvice/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/testResultAndAdvice/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/testResultAndAdvice/update/batch',
    method: 'POST',
    data})
}

   